import Transactions from "components/admin-panel/Transaction/Transactions";
import ManagementSidebar from "components/common/ManagementSidebar";

const FinancialDepartment2 = ({ type }) => {
  return (
    <div className="d-flex financial-departmen">
      {/* <ManagementSidebar></ManagementSidebar> */}
      <Transactions type={1} />
    </div>
  );
};

export default FinancialDepartment2;
